
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DocumentLink extends Vue {
  @Prop({ type: String, required: true }) public label!: string;
  @Prop({ type: String }) public venue!: string | undefined;
  @Prop({ type: String, required: true }) public type!: string;
}
